import React from 'react';
import L from 'leaflet';
import { Marker } from 'react-leaflet';

const houseIcon = L.divIcon({
  className: 'house-icon',
  iconSize: [30, 30],
  iconAnchor: [15, 15],
  html: `
    <div class="house-marker">
        <svg
          class="icon icon-house"
          width="32"
          height="29"
          viewBox="0 0 32 29"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1.656 14.756L16 2.324l14.344 12.432a1.001 1.001 0 0 0 1.312-1.511l-15-13a1 1 0 0 0-1.31 0L10 4.876V3a2 2 0 0 0-4 0v5.342L.344 13.245a1.003 1.003 0 0 0-.1 1.412c.364.415.994.462 1.412.1zM12 19h8v10h6a2 2 0 0 0 2-2v-9.802c0-.6-.268-1.165-.732-1.545l-10-8.198a1.996 1.996 0 0 0-2.536 0l-10 8.198A1.993 1.993 0 0 0 4 17.198V27a2 2 0 0 0 2 2h6V19z" fill-rule="evenodd"/>
        </svg>
      </svg>
    </div>
  `
});

export default ({ position }) => (
  position && position.length ?
    <Marker
      position={position}
      icon={houseIcon}
    /> :
    null
)
